<div
  class="display"
  [class.mobile]="platform === platformRef.mobile"
  [class.tablet]="platform === platformRef.tablet"
>
  <app-ingredient-detail-header
    [platform]="platform"
    [product]="product"
    [isOnline]="isOnline"
    [pricingDisabled]="pricingDisabled"
    (ellipsisEvent)="ellipsisClick($event)"
    (productEvent)="onProductClick($event)"
  ></app-ingredient-detail-header>
  <app-ingredient-detail-touch-values
    [platform]="platform"
    [cardData]="cardData"
    [hide]="selectedTab !== 'default' && platform === platformRef.mobile"
    (noteInputBlurEvent)="handleNoteuUpdate($event)"
    (quantityInputBlurEvent)="handleQuantityUpdate($event)"
    (uomDropdownClickEvent)="handleUOMUpdate($event)"
  ></app-ingredient-detail-touch-values>
</div>
